import typedStore from '@/store/typedStore'
import { GrowthBook } from '@growthbook/growthbook'
import { getInstance as getAuth0Instance } from '@orbica/vue-modules'

export interface GrowthBookOptions {
  featuresEndpoint: string,
  enableDevMode: boolean
}

class GrowthBookService {
  private _growthBook: GrowthBook
  private _initialized: boolean

  constructor () {
    this._growthBook = new GrowthBook()
    this._initialized = false
  }

  get growthBook () {
    const auth0 = getAuth0Instance()
    this._growthBook.setAttributes({
      loggedIn: auth0?.isAuthenticated ?? false,
      id: auth0?.user?.sub,
      email: auth0?.user?.email,
      environment: process.env.NODE_ENV,
      orgId: typedStore.primary.app.app?.orgId,
      appId: typedStore.primary.app.app?.id,
    })
    return this._growthBook
  }

  async initializeGrowthBook (options: GrowthBookOptions) {
    if (!this._initialized) {
      this._growthBook = new GrowthBook({ enableDevMode: options.enableDevMode })

      try {
        const json = await this.getFeaturesJson(options.featuresEndpoint)
        this._growthBook.setFeatures(json.features)
        this._initialized = true
      } catch (error) {
        console.error('GrowthBook initialization error', error)
      }
    }
  }

  private async getFeaturesJson (featuresEndpoint: string) {
    const response = await fetch(featuresEndpoint)
    return response.json()
  }
}

export const growthBookService = new GrowthBookService()
